export const passwordRequirementsRegEx =
  /^(?=.*[0-9])(?=.*[a-zA-Z])(?=\S+$).{8,32}$/;
